<template>
  <aside>
    <vs-sidebar
      style="background: #ebf9fc"
      hover-expand
      reduce
      v-model="active"
      open
      class=""
    >
      <!-- <template #logo>
        <div class="d-block">
          <img src="@/images/profilePic.png" alt="" />
        </div>
      </template> -->
      <p class="ml-5 pl-5 text-center">{{ user_name }}</p>

      <vs-sidebar-item   class="mt-3" to="/" id="home">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="511pt"
            viewBox="0 1 511 511.999"
            width="511pt"
          >
            <path
              d="m498.699219 222.695312c-.015625-.011718-.027344-.027343-.039063-.039062l-208.855468-208.847656c-8.902344-8.90625-20.738282-13.808594-33.328126-13.808594-12.589843 0-24.425781 4.902344-33.332031 13.808594l-208.746093 208.742187c-.070313.070313-.144532.144531-.210938.214844-18.28125 18.386719-18.25 48.21875.089844 66.558594 8.378906 8.382812 19.441406 13.234375 31.273437 13.746093.484375.046876.96875.070313 1.457031.070313h8.320313v153.695313c0 30.417968 24.75 55.164062 55.167969 55.164062h81.710937c8.285157 0 15-6.71875 15-15v-120.5c0-13.878906 11.292969-25.167969 25.171875-25.167969h48.195313c13.878906 0 25.167969 11.289063 25.167969 25.167969v120.5c0 8.28125 6.714843 15 15 15h81.710937c30.421875 0 55.167969-24.746094 55.167969-55.164062v-153.695313h7.71875c12.585937 0 24.421875-4.902344 33.332031-13.8125 18.359375-18.367187 18.367187-48.253906.027344-66.632813zm-21.242188 45.421876c-3.238281 3.238281-7.542969 5.023437-12.117187 5.023437h-22.71875c-8.285156 0-15 6.714844-15 15v168.695313c0 13.875-11.289063 25.164062-25.167969 25.164062h-66.710937v-105.5c0-30.417969-24.746094-55.167969-55.167969-55.167969h-48.195313c-30.421875 0-55.171875 24.75-55.171875 55.167969v105.5h-66.710937c-13.875 0-25.167969-11.289062-25.167969-25.164062v-168.695313c0-8.285156-6.714844-15-15-15h-22.328125c-.234375-.015625-.464844-.027344-.703125-.03125-4.46875-.078125-8.660156-1.851563-11.800781-4.996094-6.679688-6.679687-6.679688-17.550781 0-24.234375.003906 0 .003906-.003906.007812-.007812l.011719-.011719 208.847656-208.839844c3.234375-3.238281 7.535157-5.019531 12.113281-5.019531 4.574219 0 8.875 1.78125 12.113282 5.019531l208.800781 208.796875c.03125.03125.066406.0625.097656.09375 6.644531 6.691406 6.632813 17.539063-.03125 24.207032zm0 0"
            />
          </svg>
        </template>
        اﻟﺮﺋﺴﻴﺔ
      </vs-sidebar-item>
   
      <vs-sidebar-item
        v-if="!notAdmin"
        to="/add-product"
        class="mt-2"
        id="add-product"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="-42 0 512 512.001">
            <path
              d="m135.746094 380.710938c-.988282 1.796874-2.519532 2.335937-3.957032 2.335937s-2.875-.539063-3.863281-2.335937l-10.339843-19.417969v39.371093c0 2.429688-2.964844 3.6875-5.839844 3.6875-2.96875 0-5.84375-1.257812-5.84375-3.6875v-56.183593c0-4.3125 2.875-5.839844 5.84375-5.839844 4.222656 0 6.113281.898437 9.078125 6.199219l11.058593 20.136718 11.054688-20.136718c2.96875-5.300782 4.945312-6.199219 9.171875-6.199219 2.964844 0 5.839844 1.527344 5.839844 5.839844v56.183593c0 2.429688-2.964844 3.6875-5.839844 3.6875-2.96875 0-5.84375-1.257812-5.84375-3.6875v-38.652343zm0 0"
            />
            <path
              d="m190.484375 366.863281h13.664063c2.335937 0 3.683593 2.25 3.683593 4.675781 0 2.066407-1.167969 4.496094-3.683593 4.496094h-13.664063v18.066406h25.4375c2.339844 0 3.6875 2.425782 3.6875 5.214844 0 2.425782-1.167969 5.035156-3.6875 5.035156h-32c-2.605469 0-5.125-1.261718-5.125-3.6875v-58.339843c0-2.425781 2.515625-3.6875 5.125-3.6875h32c2.519531 0 3.6875 2.609375 3.6875 5.035156 0 2.789063-1.347656 5.214844-3.6875 5.214844h-25.4375zm0 0"
            />
            <path
              d="m267.519531 400.664062-19.328125-36.136718v36.136718c0 2.429688-2.964844 3.6875-5.84375 3.6875-2.964844 0-5.84375-1.257812-5.84375-3.6875v-58.339843c0-2.515625 2.878906-3.683594 5.84375-3.683594 4.226563 0 5.933594.898437 8.722656 6.199219l17.347657 33.53125v-36.136719c0-2.515625 2.875-3.597656 5.84375-3.597656 2.875 0 5.839843 1.078125 5.839843 3.597656v58.429687c0 2.425782-2.964843 3.6875-5.839843 3.6875-2.789063 0-5.214844-.898437-6.742188-3.6875zm0 0"
            />
            <path
              d="m332.148438 342.234375c0-2.515625 2.875-3.59375 5.839843-3.59375 2.878907 0 5.84375 1.078125 5.84375 3.59375v42.070313c0 15.011718-9.527343 20.585937-21.574219 20.585937-12.136718 0-21.574218-5.574219-21.574218-20.585937v-42.070313c0-2.515625 2.875-3.59375 5.84375-3.59375 2.875 0 5.839844 1.078125 5.839844 3.59375v42.070313c0 7.011718 3.6875 10.339843 9.890624 10.339843 6.203126 0 9.886719-3.328125 9.886719-10.339843v-42.070313zm0 0"
            />
            <path
              d="m355.257812 422.148438h-42.730468c-4.195313 0-7.59375 3.398437-7.59375 7.589843 0 4.195313 3.398437 7.589844 7.59375 7.589844h42.730468c4.195313 0 7.589844-3.394531 7.589844-7.589844 0-4.191406-3.394531-7.589843-7.589844-7.589843zm0 0"
            />
            <path
              d="m277.207031 422.148438h-172.941406c-4.191406 0-7.589844 3.398437-7.589844 7.589843 0 4.195313 3.398438 7.589844 7.589844 7.589844h172.941406c4.195313 0 7.589844-3.394531 7.589844-7.589844 0-4.191406-3.394531-7.589843-7.589844-7.589843zm0 0"
            />
            <path
              d="m355.257812 306.242188h-250.992187c-4.191406 0-7.589844 3.398437-7.589844 7.589843 0 4.191407 3.398438 7.589844 7.589844 7.589844h250.992187c4.195313 0 7.589844-3.398437 7.589844-7.589844 0-4.191406-3.394531-7.589843-7.589844-7.589843zm0 0"
            />
            <path
              d="m351.035156 212.128906h-7.367187c-2.84375-52.300781-41.074219-95.339844-91.109375-105.527344l1.464844-14.003906c.480468-4.570312-1.011719-9.148437-4.085938-12.558594-3.074219-3.414062-7.472656-5.371093-12.066406-5.371093h-16.214844c-4.597656 0-8.992188 1.960937-12.070312 5.371093-3.074219 3.414063-4.5625 7.992188-4.082032 12.558594l1.464844 14.003906c-50.035156 10.1875-88.265625 53.222657-91.109375 105.523438h-7.367187c-6.515626 0-11.816407 5.300781-11.816407 11.816406v15.664063c0 6.515625 5.300781 11.816406 11.816407 11.816406h242.539062c6.515625 0 11.816406-5.300781 11.816406-11.816406v-15.664063c0-6.511718-5.296875-11.8125-11.8125-11.8125zm-130.167968-121.929687c.210937-.230469.472656-.347657.789062-.347657h16.214844c.3125 0 .578125.117188.789062.347657.210938.234375.300782.511719.265625.820312l-1.417969 13.5625c-2.558593-.171875-5.140624-.269531-7.742187-.269531-2.605469 0-5.183594.097656-7.742187.269531l-1.421876-13.5625c-.03125-.308593.058594-.585937.265626-.820312zm126.800781 146.042969h-235.808594v-8.933594h31.988281c4.195313 0 7.59375-3.398438 7.59375-7.589844s-3.398437-7.589844-7.59375-7.589844h-12.777344c3.242188-51.625 46.265626-92.632812 98.691407-92.632812 52.429687 0 95.453125 41.007812 98.695312 92.632812h-149.289062c-4.195313 0-7.589844 3.398438-7.589844 7.589844s3.394531 7.589844 7.589844 7.589844h168.5zm0 0"
            />
            <path
              d="m409.484375 0h-359.441406c-10.65625 0-19.328125 8.671875-19.328125 19.328125v13.710937h-7.082032c-13.03125 0-23.632812 10.605469-23.632812 23.636719s10.601562 23.636719 23.632812 23.636719h7.082032v32.457031h-7.082032c-13.03125 0-23.632812 10.601563-23.632812 23.636719 0 13.03125 10.601562 23.632812 23.632812 23.632812h7.082032v32.460938h-7.082032c-13.03125 0-23.632812 10.601562-23.632812 23.636719 0 13.03125 10.601562 23.632812 23.632812 23.632812h7.082032v32.460938h-7.082032c-13.03125 0-23.632812 10.601562-23.632812 23.632812 0 13.035157 10.601562 23.636719 23.632812 23.636719h7.082032v32.460938h-7.082032c-13.03125 0-23.632812 10.601562-23.632812 23.632812 0 13.035156 10.601562 23.636719 23.632812 23.636719h7.082032v32.460937h-7.082032c-13.03125 0-23.632812 10.601563-23.632812 23.632813s10.601562 23.636719 23.632812 23.636719h7.082032v13.710937c0 10.65625 8.671875 19.328125 19.328125 19.328125h359.441406c10.65625 0 19.332031-8.671875 19.332031-19.328125v-473.34375c0-10.65625-8.675781-19.328125-19.332031-19.328125zm-378.773437 65.132812h-7.078126c-4.660156 0-8.453124-3.792968-8.453124-8.457031 0-4.660156 3.792968-8.453125 8.453124-8.453125h7.078126zm0 79.726563h-7.078126c-4.660156 0-8.453124-3.792969-8.453124-8.453125 0-4.664062 3.792968-8.453125 8.453124-8.453125h7.078126zm0 79.730469h-7.078126c-4.660156 0-8.453124-3.792969-8.453124-8.453125 0-4.664063 3.792968-8.457031 8.453124-8.457031h7.078126zm0 79.730468h-7.078126c-4.660156 0-8.453124-3.792968-8.453124-8.457031 0-4.660156 3.792968-8.453125 8.453124-8.453125h7.078126zm0 79.726563h-7.078126c-4.660156 0-8.453124-3.789063-8.453124-8.453125 0-4.660156 3.792968-8.453125 8.453124-8.453125h7.078126zm0 79.730469h-7.078126c-4.660156 0-8.453124-3.792969-8.453124-8.453125 0-4.664063 3.792968-8.453125 8.453124-8.453125h7.078126zm382.921874 28.890625c0 2.289062-1.859374 4.152343-4.148437 4.152343h-359.441406c-2.289063 0-4.148438-1.863281-4.148438-4.152343v-473.339844c0-2.285156 1.859375-4.148437 4.148438-4.148437h359.441406c2.289063 0 4.148437 1.863281 4.148437 4.148437zm0 0"
            />
          </svg>
        </template>
        اﻟﻤﻨﻴﻮ
      </vs-sidebar-item>
      <vs-sidebar-item v-if="!captain" class="mt-2" id="order" to="/orders">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background: new 0 0 512 512"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M458.737,422.218l-22.865-288.116c-1.425-18.562-17.123-33.103-35.739-33.103H354.97v-2.03    C354.97,44.397,310.573,0,256.001,0s-98.969,44.397-98.969,98.969v2.03H111.87c-18.617,0-34.316,14.54-35.736,33.064    L53.262,422.257c-1.77,23.075,6.235,46.048,21.961,63.026C90.949,502.261,113.242,512,136.385,512h239.231    c23.142,0,45.436-9.738,61.163-26.717C452.505,468.304,460.509,445.332,458.737,422.218z M187.022,98.969    c0-38.035,30.945-68.979,68.979-68.979s68.979,30.945,68.979,68.979v2.03H187.022V98.969z M414.776,464.905    c-10.218,11.03-24.124,17.105-39.16,17.105h-239.23c-15.036,0-28.942-6.075-39.16-17.105    c-10.217-11.031-15.211-25.363-14.063-40.315l22.87-288.195c0.232-3.032,2.796-5.406,5.837-5.406h45.162v36.935    c0,8.281,6.714,14.995,14.995,14.995c8.281,0,14.995-6.714,14.995-14.995v-36.935H324.98v36.935    c0,8.281,6.714,14.995,14.995,14.995s14.995-6.714,14.995-14.995v-36.935h45.163c3.04,0,5.604,2.375,5.84,5.446l22.865,288.115    C429.988,439.542,424.993,453.873,414.776,464.905z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M323.556,254.285c-5.854-5.856-15.349-5.856-21.204,0l-66.956,66.956l-25.746-25.746c-5.855-5.856-15.35-5.856-21.206,0    c-5.856,5.856-5.856,15.35,0,21.206l36.349,36.349c2.928,2.928,6.766,4.393,10.602,4.393s7.675-1.464,10.602-4.393l77.558-77.558    C329.412,269.635,329.412,260.141,323.556,254.285z"
                />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </template>
        اﻟﻄﻠﺒﺎﺕ
      </vs-sidebar-item>

      <!-- <vs-sidebar-item class="mt-2" id="pendding-order" to="/pendding-orders">
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
<g xmlns="http://www.w3.org/2000/svg">
	<g>
		<g>
			<path d="M458.406,380.681c-8.863-6.593-21.391-4.752-27.984,4.109c-3.626,4.874-7.506,9.655-11.533,14.21     c-7.315,8.275-6.538,20.915,1.737,28.231c3.806,3.364,8.531,5.016,13.239,5.016c5.532,0,11.04-2.283,14.992-6.754     c4.769-5.394,9.364-11.056,13.658-16.829C469.108,399.803,467.269,387.273,458.406,380.681z" fill="#404445" data-original="#000000" class=""/>
			<path d="M491.854,286.886c-10.786-2.349-21.447,4.496-23.796,15.288c-1.293,5.937-2.855,11.885-4.646,17.681     c-3.261,10.554,2.651,21.752,13.204,25.013c1.967,0.607,3.955,0.896,5.911,0.896c8.54,0,16.448-5.514,19.102-14.102     c2.126-6.878,3.98-13.937,5.514-20.98C509.492,299.89,502.647,289.236,491.854,286.886z" fill="#404445" data-original="#000000" class=""/>
			<path d="M362.139,444.734c-5.31,2.964-10.808,5.734-16.34,8.233c-10.067,4.546-14.542,16.392-9.996,26.459     c3.34,7.396,10.619,11.773,18.239,11.773c2.752,0,5.549-0.571,8.22-1.777c6.563-2.964,13.081-6.249,19.377-9.764     c9.645-5.384,13.098-17.568,7.712-27.212C383.968,442.803,371.784,439.35,362.139,444.734z" fill="#404445" data-original="#000000" class=""/>
			<path d="M236,96v151.716l-73.339,73.338c-7.81,7.811-7.81,20.474,0,28.284c3.906,3.906,9.023,5.858,14.143,5.858     c5.118,0,10.237-1.953,14.143-5.858l79.196-79.196c3.75-3.75,5.857-8.838,5.857-14.142V96c0-11.046-8.954-20-20-20     C244.954,76,236,84.954,236,96z" fill="#404445" data-original="#000000" class=""/>
			<path d="M492,43c-11.046,0-20,8.954-20,20v55.536C425.448,45.528,344.151,0,256,0C187.62,0,123.333,26.629,74.98,74.98     C26.629,123.333,0,187.62,0,256s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512c0.169,0,0.332-0.021,0.5-0.025     c0.168,0.004,0.331,0.025,0.5,0.025c7.208,0,14.487-0.304,21.637-0.902c11.007-0.922,19.183-10.592,18.262-21.599     c-0.923-11.007-10.58-19.187-21.6-18.261C269.255,471.743,263.099,472,257,472c-0.169,0-0.332,0.021-0.5,0.025     c-0.168-0.004-0.331-0.025-0.5-0.025c-119.103,0-216-96.897-216-216S136.897,40,256,40c76.758,0,147.357,40.913,185.936,106     h-54.993c-11.046,0-20,8.954-20,20s8.954,20,20,20H448c12.18,0,23.575-3.423,33.277-9.353c0.624-0.356,1.224-0.739,1.796-1.152     C500.479,164.044,512,144.347,512,122V63C512,51.954,503.046,43,492,43z" fill="#404445" data-original="#000000" class=""/>
		</g>
	</g>
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
<g xmlns="http://www.w3.org/2000/svg">
</g>
</g></svg>
        </template>
        اﻟﻄﻠﺒﺎﺕ المعلقة
      </vs-sidebar-item> -->

      <vs-sidebar-item
        v-if="!notAdmin || moshref"
        class="mt-2"
        id="order-report"
        to="/orders/report"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
          >
            <g>
              <path
                d="m187.978 356.117h133.007c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-133.007c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5zm23.501-172.063h89.042c6.791 0 12.678-4.366 14.65-10.863l18.688-61.574c1.423-4.687.565-9.632-2.353-13.566-2.917-3.934-7.399-6.19-12.297-6.19h-6.652l-13.594-33.982c-3.124-7.824-10.587-12.879-19.013-12.879h-47.9c-8.425 0-15.888 5.055-19.013 12.875l-13.594 33.985h-6.652c-4.898 0-9.38 2.256-12.298 6.191s-3.775 8.879-2.353 13.566l18.689 61.574c1.972 6.497 7.859 10.863 14.65 10.863zm-18.937-77.069c.226-.306 40.794-.026 41.084-.125 4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-18.028l11.366-28.416c.836-2.092 2.832-3.444 5.086-3.444h47.9c2.254 0 4.25 1.352 5.086 3.446l11.366 28.414h-27.777c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5c.252 0 50.641-.134 50.833.125.223.301-18.641 61.534-18.641 61.85 0 .666-89.595.131-89.635 0-.095-.315-18.863-61.55-18.64-61.85zm-4.564 323.952c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h133.007c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5zm200.507-22.5c0-4.142-3.357-7.5-7.5-7.5h-193.007c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h193.007c4.143 0 7.5-3.358 7.5-7.5zm37.5-80.131c4.143 0 7.5-3.358 7.5-7.5v-283.306c0-20.678-16.822-37.5-37.5-37.5h-279.97c-20.678 0-37.5 16.822-37.5 37.5v437c0 20.678 16.822 37.5 37.5 37.5h279.971c20.678 0 37.5-16.822 37.5-37.5v-118.694c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v118.694c0 12.407-10.094 22.5-22.5 22.5h-279.971c-12.407 0-22.5-10.093-22.5-22.5v-437c0-12.407 10.093-22.5 22.5-22.5h279.971c12.406 0 22.5 10.093 22.5 22.5v283.306c-.001 4.142 3.357 7.5 7.499 7.5zm-267.657 33.563c-3.693.046-7.566.082-11.116.1 2.522-3.424 5.712-7.841 9.689-13.524 3.488-4.983 5.956-9.494 6.599-14.181.105-.768.307-2.147.307-2.88 0-11.175-9.091-20.266-20.266-20.266-9.662 0-18.025 6.875-19.886 16.346-.798 4.064 1.849 8.007 5.914 8.805s8.007-1.849 8.805-5.914c.482-2.456 2.655-4.237 5.167-4.237 2.778 0 5.061 2.162 5.253 4.892.19 2.695-1.185 4.552-4.182 8.834-7.88 11.259-12.581 17.414-15.106 20.72-4.409 5.773-6.516 13.297 1.121 15.842.985.328 20.783.552 27.889.462 4.142-.052 7.457-3.452 7.405-7.594s-3.487-7.485-7.593-7.405zm222.657-50.752h-193.007c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h193.007c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5zm-236.267 89.82c-9.662 0-18.025 6.875-19.886 16.346-.798 4.064 1.849 8.007 5.914 8.805 4.062.797 8.006-1.849 8.805-5.914.482-2.456 2.655-4.237 5.167-4.237 2.904 0 5.266 2.362 5.266 5.266s-2.362 5.266-5.266 5.266c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c2.904 0 5.266 2.362 5.266 5.266s-2.362 5.266-5.266 5.266c-2.613 0-4.855-1.944-5.215-4.526-.034-.242-.051-.491-.051-.74 0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5c0 11.016 9.141 20.266 20.266 20.266 11.175 0 20.266-9.091 20.266-20.266 0-4.836-1.708-9.278-4.546-12.766 2.838-3.488 4.546-7.93 4.546-12.766 0-11.175-9.091-20.266-20.266-20.266zm0-114.359c4.142 0 7.5-3.358 7.5-7.5v-49.89c0-4.142-3.358-7.5-7.5-7.5h-10.664c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h3.164v42.39c0 4.142 3.358 7.5 7.5 7.5zm43.26-19.89h133.007c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-133.007c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7 .5zm193.007-45h-193.007c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h193.007c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z"
              />
            </g>
          </svg>
        </template>
        ﺗﻘﺮﻳﺮ اﻟﻄﻠﺒﺎﺕ
      </vs-sidebar-item>

      <!-- <vs-sidebar-item class="mt-2"
        id="order-rates" to="/orders-rates" v-if="!notAdmin">
        <template #icon>
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.437 15.264a.779.779 0 01-.363-.09l-4.09-2.15-4.09 2.15a.78.78 0 01-1.13-.822l.78-4.554L.235 6.573a.78.78 0 01.433-1.33l4.572-.665L7.285.435a.78.78 0 011.399 0l2.045 4.143 4.572.665a.78.78 0 01.432 1.33l-3.308 3.225.78 4.554a.78.78 0 01-.768.912zm-4.453-3.9c.125 0 .25.03.363.089l3.055 1.606-.584-3.401a.78.78 0 01.225-.69l2.47-2.41-3.414-.495a.78.78 0 01-.587-.427L7.984 2.542 6.457 5.636a.78.78 0 01-.587.427l-3.415.496 2.471 2.408a.78.78 0 01.225.69l-.584 3.402 3.055-1.606a.78.78 0 01.362-.09z" fill="#374957"/></svg>
        </template>
        تقييمات الطلبات
      </vs-sidebar-item> -->

      <!-- <vs-sidebar-item class="mt-2"
        id="promo-codes" to="/promo-codes" v-if="!notAdmin">
        <template #icon>
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.437 15.264a.779.779 0 01-.363-.09l-4.09-2.15-4.09 2.15a.78.78 0 01-1.13-.822l.78-4.554L.235 6.573a.78.78 0 01.433-1.33l4.572-.665L7.285.435a.78.78 0 011.399 0l2.045 4.143 4.572.665a.78.78 0 01.432 1.33l-3.308 3.225.78 4.554a.78.78 0 01-.768.912zm-4.453-3.9c.125 0 .25.03.363.089l3.055 1.606-.584-3.401a.78.78 0 01.225-.69l2.47-2.41-3.414-.495a.78.78 0 01-.587-.427L7.984 2.542 6.457 5.636a.78.78 0 01-.587.427l-3.415.496 2.471 2.408a.78.78 0 01.225.69l-.584 3.402 3.055-1.606a.78.78 0 01.362-.09z" fill="#374957"/></svg>
        </template>
        اكواد الخصم
      </vs-sidebar-item> -->

      <vs-sidebar-item
        class="mt-2"
        id="branch-account"
        v-if="!notAdmin"
        to="/branch-account"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="512"
            height="512"
          >
            <g id="Calculator">
              <path
                d="M49,62H15a7.008,7.008,0,0,1-7-7V9a7.008,7.008,0,0,1,7-7H49a7.008,7.008,0,0,1,7,7V55A7.008,7.008,0,0,1,49,62ZM15,4a5.006,5.006,0,0,0-5,5V55a5.006,5.006,0,0,0,5,5H49a5.006,5.006,0,0,0,5-5V9a5.006,5.006,0,0,0-5-5Z"
              />
              <path
                d="M35,58H29a3,3,0,0,1-3-3V51a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,35,58Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V51a1,1,0,0,0-1-1Z"
              />
              <path
                d="M21,58H15a3,3,0,0,1-3-3V51a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,21,58Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V51a1,1,0,0,0-1-1Z"
              />
              <path
                d="M49,58H43a3,3,0,0,1-3-3V39a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3V55A3,3,0,0,1,49,58ZM43,38a1,1,0,0,0-1,1V55a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1Z"
              />
              <path
                d="M35,46H29a3,3,0,0,1-3-3V39a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,35,46Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1Z"
              />
              <path
                d="M21,46H15a3,3,0,0,1-3-3V39a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,21,46Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1Z"
              />
              <path
                d="M35,34H29a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,35,34Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
              />
              <path
                d="M21,34H15a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,21,34Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
              />
              <path
                d="M49,34H43a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,49,34Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
              />
              <path
                d="M49,20H15a3,3,0,0,1-3-3V9a3,3,0,0,1,3-3H49a3,3,0,0,1,3,3v8A3,3,0,0,1,49,20ZM15,8a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H49a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1Z"
              />
              <path
                d="M46,17a3,3,0,0,1-3-3V12a3,3,0,0,1,6,0v2A3,3,0,0,1,46,17Zm0-6a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V12A1,1,0,0,0,46,11Z"
              />
            </g>
          </svg>
        </template>
        تقفيل اليوميه
      </vs-sidebar-item>

      <vs-sidebar-item
        v-if="!notAdmin"
        class="mt-2"
        id="orders-products"
        to="/orders/products"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 512 512"
          >
            <g id="Line_stroke_cut_Ex" data-name="Line stroke cut Ex">
              <g>
                <path
                  d="M496,88V40a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8V80H72.4A28.075,28.075,0,0,0,44.94,102.509L33.755,158.431l15.69,3.138,11.184-55.922A12.034,12.034,0,0,1,72.4,96h7V254a18.021,18.021,0,0,0,18,18H112a8,8,0,0,0,6.247-3l59.268-74.085,3.342,2.388a51.951,51.951,0,0,1,13.518,70.433c-.03.046-.059.093-.087.139l-49.1,79.939A8,8,0,0,0,144,352V496h16V418.3a68.353,68.353,0,0,0,23,10.087,68.127,68.127,0,0,0,45.2-5.169l3.593-1.758a8,8,0,0,0,3.671-10.7l-6.758-13.816a67.435,67.435,0,0,0,42.612-5.725l3.594-1.758a8,8,0,0,0,3.671-10.7l-10.141-20.733,140.126,39.445a17.993,17.993,0,0,0,22.2-12.449L462.585,272H488a8,8,0,0,0,8-8V104H480V256H216.655a67.747,67.747,0,0,0,2-16H425.371a8,8,0,0,0,7.542-10.668,16,16,0,0,1,20.421-20.418A8,8,0,0,0,464,201.371V94.629a8,8,0,0,0-10.666-7.543A16,16,0,0,1,432,72a8,8,0,0,0-8-8H144a8,8,0,0,0-8,8,16.019,16.019,0,0,1-16,16,8,8,0,0,0-8,8V200a8,8,0,0,0,8,8,16.025,16.025,0,0,1,15.8,13.448L108.155,256H97.4a2,2,0,0,1-2-2V88H96V48H480V88ZM160,397.3V354.261l9.767-15.9,10.587,21.647a67.53,67.53,0,0,0,26.516,28.7l10.636,21.747A52.386,52.386,0,0,1,160,397.3Zm100.627-18.836a52.008,52.008,0,0,1-65.9-25.486l-8.908-18.213,61.965,17.443Zm154.743,2.219a2,2,0,0,1-2.468,1.382l-230.18-64.794,10.929-17.793,180.563,55.073a8,8,0,0,0,10.153-5.959,16,16,0,0,1,19.049-12.223,7.991,7.991,0,0,0,9.426-5.76L428.451,272h17.512ZM411.893,272l-12.786,48.013a32.227,32.227,0,0,0-27.392,17.048l-169.41-51.672,5.574-9.074q1.364-2.127,2.551-4.315ZM128,193.013V102.987A32.118,32.118,0,0,0,150.988,80H417.012A32.058,32.058,0,0,0,448,104v88a32.036,32.036,0,0,0-32,32H216.84a67.794,67.794,0,0,0-26.683-39.719l-9.507-6.791a8,8,0,0,0-10.9,1.512l-22.541,28.176A32.116,32.116,0,0,0,128,193.013Z"
                />
                <path
                  d="M32.169,247.944l14.076-70.375-15.69-3.138-14.4,72a8.007,8.007,0,0,0,.023,3.245L40,360.848V496H56V360a8.006,8.006,0,0,0-.178-1.676Z"
                />
                <path
                  d="M288,208a56,56,0,1,0-56-56A56.063,56.063,0,0,0,288,208Zm0-96a40,40,0,1,1-40,40A40.045,40.045,0,0,1,288,112Z"
                />
                <rect x="384" y="112" width="48" height="16" />
              </g>
            </g>
          </svg>
        </template>
        مبيعات الأصناف
      </vs-sidebar-item>

      <!-- <vs-sidebar-item class="mt-2" id="branch-account" to="/branch-account">
        <template #icon>
          <i class="el-icon-money"></i>
        </template>
     حسابات الفروع
      </vs-sidebar-item> -->

      <vs-sidebar-item v-if="!captain" class="mt-2" id="order-statistics-0" to="/expenses/new">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
          >
            <g id="XMLID_1780_">
              <g id="XMLID_1629_">
                <path
                  id="XMLID_1707_"
                  d="m502 0h-123c-5.522 0-10 4.477-10 10s4.478 10 10 10h113v457.858l-17.329-17.329c-1.876-1.875-4.419-2.929-7.071-2.929s-5.195 1.054-7.071 2.929l-27.329 27.329-27.329-27.329c-1.876-1.875-4.419-2.929-7.071-2.929s-5.196 1.054-7.071 2.929l-27.328 27.329-27.329-27.329c-3.906-3.905-10.236-3.905-14.143 0l-27.329 27.329-27.328-27.329c-1.875-1.875-4.419-2.929-7.071-2.929s-5.195 1.054-7.071 2.929l-27.33 27.329-27.328-27.329c-1.876-1.875-4.419-2.929-7.071-2.929s-5.195 1.054-7.071 2.929l-17.33 17.329v-43.617c68.018-11.46 120-70.763 120-141.989s-51.982-130.529-120-141.989v-130.263h121c5.522 0 10-4.477 10-10s-4.478-10-10-10h-131c-5.522 0-10 4.477-10 10v138.31c-1.329-.036-2.662-.058-4-.058-79.402 0-144 64.598-144 144s64.598 144 144 144c1.338 0 2.671-.022 4-.058v65.806c0 4.044 2.437 7.691 6.173 9.239s8.038.691 10.898-2.167l27.329-27.329 27.328 27.329c1.875 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l27.329-27.329 27.328 27.329c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l27.331-27.33 27.329 27.329c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l27.328-27.329 27.329 27.329c1.876 1.875 4.419 2.929 7.071 2.929s5.196-1.054 7.071-2.929l27.328-27.329 27.329 27.329c1.913 1.913 4.471 2.929 7.073 2.929 1.288 0 2.588-.249 3.825-.762 3.736-1.548 6.173-5.194 6.173-9.239v-491.999c.002-5.523-4.475-10-9.998-10zm-482 292.252c0-68.374 55.626-124 124-124s124 55.626 124 124-55.626 124-124 124-124-55.626-124-124z"
                />
                <path
                  id="XMLID_1708_"
                  d="m176.607 226.44c-4.966-2.411-10.951-.342-13.363 4.627l-55.024 113.305c-2.413 4.968-.341 10.952 4.627 13.364 1.407.683 2.895 1.007 4.361 1.007 3.709 0 7.273-2.073 9.002-5.634l55.024-113.305c2.413-4.968.341-10.951-4.627-13.364z"
                />
                <path
                  id="XMLID_1714_"
                  d="m128.098 243.455c0-17.648-14.357-32.005-32.005-32.005s-32.006 14.357-32.006 32.005 14.357 32.005 32.006 32.005c17.647 0 32.005-14.357 32.005-32.005zm-32.005 12.005c-6.62 0-12.006-5.386-12.006-12.005s5.386-12.005 12.006-12.005c6.619 0 12.005 5.386 12.005 12.005s-5.386 12.005-12.005 12.005z"
                />
                <path
                  id="XMLID_1738_"
                  d="m193.687 309.043c-17.648 0-32.006 14.357-32.006 32.005s14.357 32.006 32.006 32.006c17.647 0 32.005-14.358 32.005-32.006s-14.358-32.005-32.005-32.005zm0 44.011c-6.62 0-12.006-5.386-12.006-12.006s5.386-12.005 12.006-12.005c6.619 0 12.005 5.386 12.005 12.005 0 6.62-5.386 12.006-12.005 12.006z"
                />
                <path
                  id="XMLID_1752_"
                  d="m344 108v-44c0-5.523-4.478-10-10-10h-132c-5.522 0-10 4.477-10 10v44c0 5.523 4.478 10 10 10h132c5.523 0 10-4.477 10-10zm-20-10h-112v-24h112z"
                />
                <path
                  id="XMLID_1753_"
                  d="m258 162h76c5.522 0 10-4.477 10-10s-4.478-10-10-10h-76c-5.522 0-10 4.477-10 10s4.478 10 10 10z"
                />
                <path
                  id="XMLID_1754_"
                  d="m448 300h-118c-5.522 0-10 4.477-10 10s4.478 10 10 10h118c5.522 0 10-4.477 10-10s-4.477-10-10-10z"
                />
                <path
                  id="XMLID_1757_"
                  d="m448 356h-118c-5.522 0-10 4.477-10 10s4.478 10 10 10h118c5.522 0 10-4.477 10-10s-4.477-10-10-10z"
                />
                <path
                  id="XMLID_1758_"
                  d="m448 412h-118c-5.522 0-10 4.477-10 10s4.478 10 10 10h118c5.522 0 10-4.477 10-10s-4.477-10-10-10z"
                />
                <path
                  id="XMLID_1759_"
                  d="m334 20c2.63 0 5.21-1.07 7.069-2.93 1.861-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.07 4.44 2.93 7.07 2.93z"
                />
                <path
                  id="XMLID_676_"
                  d="m436.007 147.951c-2.96-1.046-5.985-2.141-9.007-3.279v-52.299c8.234 1.987 13.057 6.141 13.387 6.432 1.788 1.677 4.165 2.684 6.81 2.684 5.523 0 10-4.477 10-10 0-2.936-1.268-5.572-3.282-7.402-.597-.549-10.56-9.533-26.915-12.087v-11.132c0-5.523-4.478-10-10-10s-10 4.477-10 10v11.574c-2.062.401-4.173.908-6.339 1.561-15.086 4.544-26.36 17.463-29.423 33.716-2.789 14.795 1.935 29.049 12.326 37.199 5.846 4.585 13.181 8.77 23.436 13.24v65.213c-9.385-.462-15.327-2.343-25.525-9.014-4.626-3.024-10.821-1.726-13.843 2.895-3.023 4.622-1.728 10.819 2.894 13.843 14.182 9.277 23.689 11.752 36.475 12.283v12.259c0 5.523 4.478 10 10 10s10-4.477 10-10v-13.247c23.508-4.792 37.241-24.256 40.299-42.443 3.945-23.472-8.338-43.882-31.293-51.996zm-29.007-11.903c-4.221-2.17-8.021-4.458-11.092-6.866-4.494-3.524-6.416-10.33-5.017-17.759 1.313-6.965 6.654-15.58 16.108-18.428.192-.058-.191.055 0 0v43.053zm40.576 60.582c-1.692 10.063-8.684 20.76-20.576 24.993v-55.649c.77.276 1.548.553 2.341.834 20.362 7.197 19.106 24.646 18.235 29.822z"
                />
              </g>
            </g>
          </svg>
        </template>
        اﻟﻤﺼﺮﻭﻓﺎﺕ
      </vs-sidebar-item>

      <!-- 
      <vs-sidebar-item class="mt-2" id="offers" to="/offers"  v-if="!notAdmin">
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g id="XMLID_1780_"><g id="XMLID_1629_"><path id="XMLID_1707_" d="m502 0h-123c-5.522 0-10 4.477-10 10s4.478 10 10 10h113v457.858l-17.329-17.329c-1.876-1.875-4.419-2.929-7.071-2.929s-5.195 1.054-7.071 2.929l-27.329 27.329-27.329-27.329c-1.876-1.875-4.419-2.929-7.071-2.929s-5.196 1.054-7.071 2.929l-27.328 27.329-27.329-27.329c-3.906-3.905-10.236-3.905-14.143 0l-27.329 27.329-27.328-27.329c-1.875-1.875-4.419-2.929-7.071-2.929s-5.195 1.054-7.071 2.929l-27.33 27.329-27.328-27.329c-1.876-1.875-4.419-2.929-7.071-2.929s-5.195 1.054-7.071 2.929l-17.33 17.329v-43.617c68.018-11.46 120-70.763 120-141.989s-51.982-130.529-120-141.989v-130.263h121c5.522 0 10-4.477 10-10s-4.478-10-10-10h-131c-5.522 0-10 4.477-10 10v138.31c-1.329-.036-2.662-.058-4-.058-79.402 0-144 64.598-144 144s64.598 144 144 144c1.338 0 2.671-.022 4-.058v65.806c0 4.044 2.437 7.691 6.173 9.239s8.038.691 10.898-2.167l27.329-27.329 27.328 27.329c1.875 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l27.329-27.329 27.328 27.329c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l27.331-27.33 27.329 27.329c1.876 1.875 4.419 2.929 7.071 2.929s5.195-1.054 7.071-2.929l27.328-27.329 27.329 27.329c1.876 1.875 4.419 2.929 7.071 2.929s5.196-1.054 7.071-2.929l27.328-27.329 27.329 27.329c1.913 1.913 4.471 2.929 7.073 2.929 1.288 0 2.588-.249 3.825-.762 3.736-1.548 6.173-5.194 6.173-9.239v-491.999c.002-5.523-4.475-10-9.998-10zm-482 292.252c0-68.374 55.626-124 124-124s124 55.626 124 124-55.626 124-124 124-124-55.626-124-124z"/><path id="XMLID_1708_" d="m176.607 226.44c-4.966-2.411-10.951-.342-13.363 4.627l-55.024 113.305c-2.413 4.968-.341 10.952 4.627 13.364 1.407.683 2.895 1.007 4.361 1.007 3.709 0 7.273-2.073 9.002-5.634l55.024-113.305c2.413-4.968.341-10.951-4.627-13.364z"/><path id="XMLID_1714_" d="m128.098 243.455c0-17.648-14.357-32.005-32.005-32.005s-32.006 14.357-32.006 32.005 14.357 32.005 32.006 32.005c17.647 0 32.005-14.357 32.005-32.005zm-32.005 12.005c-6.62 0-12.006-5.386-12.006-12.005s5.386-12.005 12.006-12.005c6.619 0 12.005 5.386 12.005 12.005s-5.386 12.005-12.005 12.005z"/><path id="XMLID_1738_" d="m193.687 309.043c-17.648 0-32.006 14.357-32.006 32.005s14.357 32.006 32.006 32.006c17.647 0 32.005-14.358 32.005-32.006s-14.358-32.005-32.005-32.005zm0 44.011c-6.62 0-12.006-5.386-12.006-12.006s5.386-12.005 12.006-12.005c6.619 0 12.005 5.386 12.005 12.005 0 6.62-5.386 12.006-12.005 12.006z"/><path id="XMLID_1752_" d="m344 108v-44c0-5.523-4.478-10-10-10h-132c-5.522 0-10 4.477-10 10v44c0 5.523 4.478 10 10 10h132c5.523 0 10-4.477 10-10zm-20-10h-112v-24h112z"/><path id="XMLID_1753_" d="m258 162h76c5.522 0 10-4.477 10-10s-4.478-10-10-10h-76c-5.522 0-10 4.477-10 10s4.478 10 10 10z"/><path id="XMLID_1754_" d="m448 300h-118c-5.522 0-10 4.477-10 10s4.478 10 10 10h118c5.522 0 10-4.477 10-10s-4.477-10-10-10z"/><path id="XMLID_1757_" d="m448 356h-118c-5.522 0-10 4.477-10 10s4.478 10 10 10h118c5.522 0 10-4.477 10-10s-4.477-10-10-10z"/><path id="XMLID_1758_" d="m448 412h-118c-5.522 0-10 4.477-10 10s4.478 10 10 10h118c5.522 0 10-4.477 10-10s-4.477-10-10-10z"/><path id="XMLID_1759_" d="m334 20c2.63 0 5.21-1.07 7.069-2.93 1.861-1.86 2.931-4.44 2.931-7.07s-1.07-5.21-2.931-7.07c-1.859-1.86-4.439-2.93-7.069-2.93s-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07 1.069 5.21 2.93 7.07 4.44 2.93 7.07 2.93z"/><path id="XMLID_676_" d="m436.007 147.951c-2.96-1.046-5.985-2.141-9.007-3.279v-52.299c8.234 1.987 13.057 6.141 13.387 6.432 1.788 1.677 4.165 2.684 6.81 2.684 5.523 0 10-4.477 10-10 0-2.936-1.268-5.572-3.282-7.402-.597-.549-10.56-9.533-26.915-12.087v-11.132c0-5.523-4.478-10-10-10s-10 4.477-10 10v11.574c-2.062.401-4.173.908-6.339 1.561-15.086 4.544-26.36 17.463-29.423 33.716-2.789 14.795 1.935 29.049 12.326 37.199 5.846 4.585 13.181 8.77 23.436 13.24v65.213c-9.385-.462-15.327-2.343-25.525-9.014-4.626-3.024-10.821-1.726-13.843 2.895-3.023 4.622-1.728 10.819 2.894 13.843 14.182 9.277 23.689 11.752 36.475 12.283v12.259c0 5.523 4.478 10 10 10s10-4.477 10-10v-13.247c23.508-4.792 37.241-24.256 40.299-42.443 3.945-23.472-8.338-43.882-31.293-51.996zm-29.007-11.903c-4.221-2.17-8.021-4.458-11.092-6.866-4.494-3.524-6.416-10.33-5.017-17.759 1.313-6.965 6.654-15.58 16.108-18.428.192-.058-.191.055 0 0v43.053zm40.576 60.582c-1.692 10.063-8.684 20.76-20.576 24.993v-55.649c.77.276 1.548.553 2.341.834 20.362 7.197 19.106 24.646 18.235 29.822z"/></g></g></svg>
        </template>
        العروض
      </vs-sidebar-item> -->

      <vs-sidebar-item
        v-if="!notAdmin"
        class="mt-2"
        id="order-statistics"
        to="/orders/statistics"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 480 480"
            style="enable-background: new 0 0 480 480"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M272,176.232h-64c-4.418,0-8,3.582-8,8v224c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-224    C280,179.813,276.418,176.232,272,176.232z M264,400.232h-48v-208h48V400.232z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M464,144.232h-64c-4.418,0-8,3.582-8,8v256c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-256    C472,147.813,468.418,144.232,464,144.232z M456,400.232h-48v-240h48V400.232z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M368,320.232h-64c-4.418,0-8,3.582-8,8v80c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-80    C376,323.813,372.418,320.232,368,320.232z M360,400.232h-48v-64h48V400.232z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M80,208.232H16c-4.418,0-8,3.582-8,8v192c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-192    C88,211.813,84.418,208.232,80,208.232z M72,400.232H24v-176h48V400.232z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M176,256.232h-64c-4.418,0-8,3.582-8,8v144c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-144    C184,259.813,180.418,256.232,176,256.232z M168,400.232h-48v-128h48V400.232z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M432.465,7.769c-17.801-0.128-32.335,14.198-32.463,31.999c-0.065,8.988,3.626,17.595,10.183,23.743l-66.4,121.784    c-6.015-1.665-12.404-1.37-18.24,0.84L263.776,93.44c11.835-13.125,10.789-33.36-2.337-45.194s-33.36-10.789-45.194,2.337    c-8.695,9.644-10.701,23.586-5.077,35.29L162.6,126.296c-13.324-9.719-31.884-7.544-42.6,4.992L79.272,110.92    c3.694-17.283-7.323-34.288-24.605-37.981c-17.283-3.694-34.288,7.322-37.981,24.605c-3.694,17.283,7.322,34.288,24.605,37.981    c2.205,0.471,4.454,0.708,6.709,0.707c9.225-0.03,17.982-4.064,24-11.056l40.728,20.368c-3.843,17.25,7.026,34.35,24.276,38.193    c17.25,3.843,34.35-7.026,38.193-24.276c1.563-7.015,0.719-14.352-2.397-20.829l48.568-40.424    c8.371,6.195,19.299,7.759,29.072,4.16l61.752,92.696c-11.803,13.154-10.707,33.386,2.448,45.189    c13.154,11.803,33.386,10.707,45.189-2.448c11.658-12.993,10.752-32.931-2.036-44.813l66.4-121.784    c2.55,0.666,5.173,1.01,7.808,1.024c17.801,0.128,32.335-14.198,32.463-31.999S450.265,7.898,432.465,7.769z M48,120.232    c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S56.837,120.232,48,120.232z M144,168.232c-8.837,0-16-7.163-16-16    s7.163-16,16-16s16,7.163,16,16S152.837,168.232,144,168.232z M240,88.232c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16    S248.837,88.232,240,88.232z M336,232.232c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S344.837,232.232,336,232.232z     M432,56.232c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16S440.837,56.232,432,56.232z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M472,424.232H8c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h464c4.418,0,8-3.582,8-8v-32    C480,427.813,476.418,424.232,472,424.232z M464,456.232H16v-16h448V456.232z"
                />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </template>
        اﻻﺣﺼﺎﺋﻴﺎﺕ
      </vs-sidebar-item>
      <!-- <vs-sidebar-item v-if="!notAdmin" class="mt-2" id="order-saless" to="/orders/branches-sales">
        <template #icon>
          <i class="el-icon-money"></i>
        </template>
      مبيعات الفروع
      </vs-sidebar-item> -->
      <vs-sidebar-item v-if="!captain" to="/driver-orders" class="mt-2" id="star">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
          >
            <g>
              <path
                d="m484.827 157.974h-86.825c-14.983 0-27.173 12.196-27.173 27.188v99.934h-32.476c1.805-6.561 2.474-14.3 2.035-23.306v-.001c-.705-38.059-7.611-70.135-20.528-95.337-10.03-19.567-21.735-31.298-31.779-38.311 11.789-12.121 18.605-29.364 18.605-49.251 0-35.781-28.543-64.89-63.626-64.89s-63.626 29.109-63.626 64.89c0 4.143 3.358 7.5 7.5 7.5h5.096c-.469 2.83-.719 5.714-.719 8.643 0 25.216 18.018 46.291 41.84 51.014-2.497 9.272-3.738 20.205-3.733 32.625l-18.706 16.089-45.515 3.681-52.503-17.356c-4.812-1.6-10.266-3.408-14.998.004-4.663 3.365-4.663 9.256-4.663 11.191v39.035c0 4.143 3.358 7.5 7.5 7.5h8.929l-13.695 47.324c-1.151 3.978 1.141 8.138 5.12 9.289 3.981 1.157 8.138-1.141 9.29-5.119l14.902-51.494h21.322c-26.52 80.872-11.388 134.854 11.871 189.485h-13.482l-56.153-62.786 11.874-41.02c1.152-3.979-1.14-8.138-5.119-9.289s-8.138 1.141-9.29 5.119l-11.357 39.237c-35.126-.586-66.546 23.632-74.553 58.475-.927 4.036 1.592 8.06 5.627 8.988l10.647 2.45c-2.72 28.252 15.885 54.907 44.259 61.438 4.309.993 8.655 1.483 12.971 1.483 10.644 0 21.101-2.984 30.35-8.781 10.855-6.802 18.943-16.802 23.32-28.62l8.401 1.933c2.503.579 4.877.872 7.249-.405 2.207-1.188 3.674-3.333 4.224-5.754.528-2.455.93-4.95 1.209-7.468h156.858c5.016 31.187 31.551 54.696 63.242 54.696s58.227-23.509 63.243-54.696h5.724s1.136.013 1.395.013c2.145 0 5.243-.238 7.787-2.826 1.273-1.295 2.767-3.612 2.652-7.293-.211-7.043-1.268-13.848-3.072-20.316 5.974-36.268.226-58.357-8.295-75.644 5.387-3.531 8.959-9.615 8.959-16.527v-20.613h37.883c14.983 0 27.173-12.196 27.173-27.188v-87.746c.002-14.991-12.187-27.187-27.171-27.187zm-388.746 312.933c-9.601 6.017-20.961 7.93-31.989 5.391h-.001c-20.298-4.672-33.84-23.285-32.853-43.411l81.353 18.724c-3.366 7.925-9.061 14.628-16.51 19.296zm37.528-29.866-116.665-26.846c9.003-24.654 33.231-40.974 59.714-39.57l57.151 63.901c-.05.843-.116 1.681-.2 2.515zm113.285-130.695c-2.177 5.742-2.177 12.821-2.177 22.62v28.302h-27.463v-38.828c0-43.898 23.958-51.721 34.71-53.012h73.529c-.296 9.963-2.544 17.045-6.812 21.54-4.974 5.238-13.485 7.79-26.021 7.802l-26.921.028c-9.6.001-15.94 3.885-18.845 11.548zm-2.177 65.921v17.908c-.068 0-.138 0-.21 0h-53.273c.599-5.554 2.329-9.852 5.17-12.826 4.226-4.422 10.178-5.082 13.35-5.082zm80.445-121.838h-68.207c-2.739-8.619-5.181-18.057-7.189-27.757l20.737-13.46c11.32-7.351 17.209-17.738 16.157-28.499-.932-9.539-7.417-18.06-16.521-21.707-8.314-3.33-17.263-2.284-25.172 2.773.652-7.174 1.866-13.578 3.622-19.014 3.197-.33 6.372-.955 9.49-1.872 6.347-1.474 12.212-3.823 17.507-6.938 14.445 8.63 46.215 36.622 49.576 116.474zm-130.179-183.038c3.537-23.964 23.749-42.39 48.077-42.39 26.812 0 48.626 22.381 48.626 49.89 0 22.374-10.729 40.407-28.029 48.343v-39.463c0-6.833-2.615-15.215-15.069-16.349-.226-.021-.453-.031-.68-.031zm11.329 23.643c0-2.96.337-5.851 1-8.643h40.228c.463.05.801.104 1.043.153.039.278.073.678.073 1.227v43.876c-1.787.263-3.585.396-5.382.397-.017 0-.034 0-.05 0-20.356-.019-36.912-16.614-36.912-37.01zm-9.723 115.92 17.764-1.437c1.583-.127 3.084-.754 4.289-1.789l32.06-27.575.005-.005c3.1-2.671 6.409-4.041 9.631-4.041 1.434 0 2.851.272 4.224.822 3.963 1.587 6.777 5.215 7.171 9.241.495 5.067-2.843 10.203-9.396 14.459l-35.725 23.188h-30.021v-12.863zm-31.696 2.564 16.696-1.35v11.651h-19.401c-2.515 0-3.128-2.09-3.2-3.843-.041-.994.053-5.978 5.905-6.458zm-17.751-5.178c-2.259 3.704-3.314 8.037-3.141 12.25.045 1.091.184 2.142.378 3.166 0 .021-.012.042-.008.062h-36.336v-28.473l39.136 12.937c-.012.02-.018.039-.029.058zm15.088 30.478h66.601c1.449 0 2.868-.42 4.083-1.209l3.395-2.204c1.633 7.218 3.493 14.242 5.519 20.876-15.296 4.515-39.575 19.106-39.575 66.158v39.581c-5.262 1.062-11.487 3.516-16.694 8.965-5.489 5.744-8.624 13.527-9.376 23.189h-15.13c-15.246-43.938-21.044-90.694 1.177-155.356zm12.362 189.458c-2.772-6.375-5.444-12.726-7.96-19.101h77.874c10.093 0 15.21-4.595 15.21-13.656v-26.752-28.302h59.199c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-59.145c.096-4.26.369-7.744 1.15-9.802.379-1.001.707-1.865 4.826-1.865l26.928-.028c16.865-.016 28.93-4.096 36.885-12.474.368-.388.716-.795 1.065-1.2h47.706 53.615v20.613c0 2.578-2.173 4.756-4.745 4.756h-74.665c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h70.258c5.928 11.003 11.26 24.694 10.943 46.325-14.838-20.611-38.859-33.864-66.121-33.864-21.894 0-42.438 8.588-57.849 24.183-13.675 13.837-21.888 31.796-23.578 51.192zm193.958 54.723c-23.446 0-43.22-16.893-48.004-39.696h96.008c-4.785 22.801-24.559 39.696-48.004 39.696zm56.524-54.696h-113.046-10.775c3.682-33.913 32.038-60.377 66.362-60.377 30.135 0 55.442 19.871 63.823 47.688.027.088.054.176.084.263 1.185 3.991 2.022 8.145 2.475 12.426zm71.926-155.395c0 6.721-5.461 12.188-12.173 12.188h-98.998v-38.731h111.171zm0-41.543h-111.171v-15.951h111.171zm0-30.951h-111.171v-15.252c0-6.721 5.461-12.188 12.173-12.188h86.825c6.712 0 12.173 5.468 12.173 12.188z"
              />
            </g>
          </svg>
        </template>
        الدليفري
      </vs-sidebar-item>

      <!-- <vs-sidebar-item @click.native="printBarCode" class="mt-2" id="barcode">
        <div @click="printBarCode">
          طباعة باركود
        </div>
      </vs-sidebar-item> -->

      <!-- <vs-sidebar-item class="mt-2" id="service">
        <template #icon>
          <i class="fas fa-concierge-bell"></i>
        </template>
        ﺧﺪﻣﺔ اﻟﻌﻤﻼء
      </vs-sidebar-item>
      <vs-sidebar-item class="mt-2" id="time0">
        <template #icon>
          <i class="far fa-clock"></i>
        </template>
        ﻣﺘﺎﺑﻌﺔ اﻟﻄﻠﺒﺎﺕ
      </vs-sidebar-item> -->

      <vs-sidebar-item
        v-if="!notAdmin"
        class="mt-2"
        to="/operations"
        id="operations"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background: new 0 0 512 512"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M490.667,405.333h-56.811C424.619,374.592,396.373,352,362.667,352s-61.931,22.592-71.189,53.333H21.333    C9.557,405.333,0,414.891,0,426.667S9.557,448,21.333,448h270.144c9.237,30.741,37.483,53.333,71.189,53.333    s61.931-22.592,71.189-53.333h56.811c11.797,0,21.333-9.557,21.333-21.333S502.464,405.333,490.667,405.333z M362.667,458.667    c-17.643,0-32-14.357-32-32s14.357-32,32-32s32,14.357,32,32S380.309,458.667,362.667,458.667z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M490.667,64h-56.811c-9.259-30.741-37.483-53.333-71.189-53.333S300.736,33.259,291.477,64H21.333    C9.557,64,0,73.557,0,85.333s9.557,21.333,21.333,21.333h270.144C300.736,137.408,328.96,160,362.667,160    s61.931-22.592,71.189-53.333h56.811c11.797,0,21.333-9.557,21.333-21.333S502.464,64,490.667,64z M362.667,117.333    c-17.643,0-32-14.357-32-32c0-17.643,14.357-32,32-32s32,14.357,32,32C394.667,102.976,380.309,117.333,362.667,117.333z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M490.667,234.667H220.523c-9.259-30.741-37.483-53.333-71.189-53.333s-61.931,22.592-71.189,53.333H21.333    C9.557,234.667,0,244.224,0,256c0,11.776,9.557,21.333,21.333,21.333h56.811c9.259,30.741,37.483,53.333,71.189,53.333    s61.931-22.592,71.189-53.333h270.144c11.797,0,21.333-9.557,21.333-21.333C512,244.224,502.464,234.667,490.667,234.667z     M149.333,288c-17.643,0-32-14.357-32-32s14.357-32,32-32c17.643,0,32,14.357,32,32S166.976,288,149.333,288z"
                />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </template>
        اﻟﻌﻤﻠﻴﺎﺕ
      </vs-sidebar-item>

      <vs-sidebar-item
        v-if="!notAdmin"
        class="mt-2"
        to="/users-accounts"
        id="users-accounts"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="-42 0 512 512.001">
            <path
              d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0"
            />
            <path
              d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0"
            />
          </svg>
        </template>
        عرض الحسابات
      </vs-sidebar-item>

      <vs-sidebar-item v-if="!notAdmin" class="mt-2" to="/stores" id="stores">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 489.4 489.4"
            style="enable-background: new 0 0 489.4 489.4"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M347.7,263.75h-66.5c-18.2,0-33,14.8-33,33v51c0,18.2,14.8,33,33,33h66.5c18.2,0,33-14.8,33-33v-51    C380.7,278.55,365.9,263.75,347.7,263.75z M356.7,347.75c0,5-4.1,9-9,9h-66.5c-5,0-9-4.1-9-9v-51c0-5,4.1-9,9-9h66.5    c5,0,9,4.1,9,9V347.75z"
                />
                <path
                  d="M489.4,171.05c0-2.1-0.5-4.1-1.6-5.9l-72.8-128c-2.1-3.7-6.1-6.1-10.4-6.1H84.7c-4.3,0-8.3,2.3-10.4,6.1l-72.7,128    c-1,1.8-1.6,3.8-1.6,5.9c0,28.7,17.3,53.3,42,64.2v211.1c0,6.6,5.4,12,12,12h66.3c0.1,0,0.2,0,0.3,0h93c0.1,0,0.2,0,0.3,0h221.4    c6.6,0,12-5.4,12-12v-209.6c0-0.5,0-0.9-0.1-1.3C472,224.55,489.4,199.85,489.4,171.05z M91.7,55.15h305.9l56.9,100.1H34.9    L91.7,55.15z M348.3,179.15c-3.8,21.6-22.7,38-45.4,38c-22.7,0-41.6-16.4-45.4-38H348.3z M232,179.15c-3.8,21.6-22.7,38-45.4,38    s-41.6-16.4-45.5-38H232z M24.8,179.15h90.9c-3.8,21.6-22.8,38-45.5,38C47.5,217.25,28.6,200.75,24.8,179.15z M201.6,434.35h-69    v-129.5c0-9.4,7.6-17.1,17.1-17.1h34.9c9.4,0,17.1,7.6,17.1,17.1v129.5H201.6z M423.3,434.35H225.6v-129.5    c0-22.6-18.4-41.1-41.1-41.1h-34.9c-22.6,0-41.1,18.4-41.1,41.1v129.6H66v-193.3c1.4,0.1,2.8,0.1,4.2,0.1    c24.2,0,45.6-12.3,58.2-31c12.6,18.7,34,31,58.2,31s45.5-12.3,58.2-31c12.6,18.7,34,31,58.1,31c24.2,0,45.5-12.3,58.1-31    c12.6,18.7,34,31,58.2,31c1.4,0,2.7-0.1,4.1-0.1L423.3,434.35L423.3,434.35z M419.2,217.25c-22.7,0-41.6-16.4-45.4-38h90.9    C460.8,200.75,441.9,217.25,419.2,217.25z"
                />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </template>
        المخازن
      </vs-sidebar-item>
      <vs-sidebar-item v-if="!notAdmin" class="mt-2" to="/purchases" id="purchases">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 489.4 489.4"
            style="enable-background: new 0 0 489.4 489.4"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M347.7,263.75h-66.5c-18.2,0-33,14.8-33,33v51c0,18.2,14.8,33,33,33h66.5c18.2,0,33-14.8,33-33v-51    C380.7,278.55,365.9,263.75,347.7,263.75z M356.7,347.75c0,5-4.1,9-9,9h-66.5c-5,0-9-4.1-9-9v-51c0-5,4.1-9,9-9h66.5    c5,0,9,4.1,9,9V347.75z"
                />
                <path
                  d="M489.4,171.05c0-2.1-0.5-4.1-1.6-5.9l-72.8-128c-2.1-3.7-6.1-6.1-10.4-6.1H84.7c-4.3,0-8.3,2.3-10.4,6.1l-72.7,128    c-1,1.8-1.6,3.8-1.6,5.9c0,28.7,17.3,53.3,42,64.2v211.1c0,6.6,5.4,12,12,12h66.3c0.1,0,0.2,0,0.3,0h93c0.1,0,0.2,0,0.3,0h221.4    c6.6,0,12-5.4,12-12v-209.6c0-0.5,0-0.9-0.1-1.3C472,224.55,489.4,199.85,489.4,171.05z M91.7,55.15h305.9l56.9,100.1H34.9    L91.7,55.15z M348.3,179.15c-3.8,21.6-22.7,38-45.4,38c-22.7,0-41.6-16.4-45.4-38H348.3z M232,179.15c-3.8,21.6-22.7,38-45.4,38    s-41.6-16.4-45.5-38H232z M24.8,179.15h90.9c-3.8,21.6-22.8,38-45.5,38C47.5,217.25,28.6,200.75,24.8,179.15z M201.6,434.35h-69    v-129.5c0-9.4,7.6-17.1,17.1-17.1h34.9c9.4,0,17.1,7.6,17.1,17.1v129.5H201.6z M423.3,434.35H225.6v-129.5    c0-22.6-18.4-41.1-41.1-41.1h-34.9c-22.6,0-41.1,18.4-41.1,41.1v129.6H66v-193.3c1.4,0.1,2.8,0.1,4.2,0.1    c24.2,0,45.6-12.3,58.2-31c12.6,18.7,34,31,58.2,31s45.5-12.3,58.2-31c12.6,18.7,34,31,58.1,31c24.2,0,45.5-12.3,58.1-31    c12.6,18.7,34,31,58.2,31c1.4,0,2.7-0.1,4.1-0.1L423.3,434.35L423.3,434.35z M419.2,217.25c-22.7,0-41.6-16.4-45.4-38h90.9    C460.8,200.75,441.9,217.25,419.2,217.25z"
                />
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </template>
        الخامات
      </vs-sidebar-item>

      <vs-sidebar-item
        v-if="!notAdmin"
        class="mt-2"
        to="/register"
        id="register"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
          >
            <g>
              <path
                d="m511 317c0-57.897-47.103-105-105-105-30.88 0-58.686 13.401-77.916 34.691-11.197-5.725-22.815-10.488-34.724-14.254 35.218-22.367 58.64-61.716 58.64-106.437 0-69.477-56.523-126-126-126s-126 56.523-126 126c0 44.624 23.319 83.901 58.41 106.293-34.163 10.711-65.468 29.567-91.509 55.607-42.497 42.497-65.901 98.999-65.901 159.099v50.001c0 8.284 6.716 15 15 15h420c8.284 0 15-6.716 15-15v-50.001c0-11.275-.885-22.645-2.614-33.945 36.844-16.321 62.614-53.232 62.614-96.054zm-381-191c0-52.935 43.065-96 96-96s96 43.065 96 96-43.065 96-96 96-96-43.065-96-96zm291 320.999v35.001h-390v-35.001c0-107.522 87.477-194.999 195-194.999 29.47 0 58.645 6.83 85.229 19.819-6.554 13.693-10.229 29.015-10.229 45.181 0 57.897 47.103 105 105 105 4.488 0 8.911-.284 13.252-.833 1.158 8.616 1.748 17.26 1.748 25.832zm6.7-58.212c-.373.094-.743.193-1.103.314-6.549 1.874-13.454 2.899-20.597 2.899-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75c0 33.811-22.494 62.457-53.3 71.787z"
              />
              <path
                d="m436 302h-15v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15h15v15c0 8.284 6.716 15 15 15s15-6.716 15-15v-15h15c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
            </g>
          </svg>
        </template>
        حساب جديد
      </vs-sidebar-item>

      <vs-sidebar-item class="mt-2" @click.native="logout()" id="logout">
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="512"
            viewBox="0 0 512 512"
            width="512"
          >
            <g id="Solid">
              <path
                d="m480.971 239.029-90.51-90.509a24 24 0 0 0 -33.942 0 24 24 0 0 0 0 33.941l49.54 49.539h-262.059a24 24 0 0 0 -24 24 24 24 0 0 0 24 24h262.059l-49.54 49.539a24 24 0 0 0 33.942 33.941l90.51-90.51a24 24 0 0 0 0-33.941z"
              />
              <path
                d="m304 392a24 24 0 0 0 -24 24v24h-208v-368h208v24a24 24 0 0 0 48 0v-32a40 40 0 0 0 -40-40h-224a40 40 0 0 0 -40 40v384a40 40 0 0 0 40 40h224a40 40 0 0 0 40-40v-32a24 24 0 0 0 -24-24z"
              />
            </g>
          </svg>
        </template>
        ﺗﺴﺠﻴﻞ اﻟﺨﺮﻭﺝ
      </vs-sidebar-item>
    </vs-sidebar>
  </aside>
</template>
<script>
// const {autoUpdate} = require('electron-auto-update');
export default {
  data: () => ({
    active: "home",
    barcodeValue: "zeyad",
    user_name: JSON.parse(localStorage.getItem("heavenDashboardUser")).name,
  }),
  methods: {
    triggerUpdates() {
      // Assign the updater to a variable that you can call manually
      // const updater = autoUpdate();
      // // Call at some point later:
      // updater.triggerUpdateCheck();
    },
    printBarCode() {
      const { ipcRenderer } = require("electron");

      ipcRenderer.send("printBarCode");
    },
    logout() {
      this.$store.commit("Logout");
    },
  },
  computed: {
    notAdmin() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id != 1) {
        return true;
      } else {
        return false;
      }
    },
    moshref() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id == 3) {
        return true;
      } else {
        return false;
      }
    },
      captain() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id == 4) {
        return true;
      } else {
        return false;
      }
    },
      salaCashier() {
      let user = localStorage.getItem("heavenDashboardUser");
      if (JSON.parse(user).role_id == 2) {
        return true;
      } else {
        return false;
      }
    },
  },
  
};
</script>
<style lang="scss">
@import "../styles/sidebar.scss";

.vs-sidebar {
  svg {
    width: 25px;
    height: 25px;
  }
}
</style>
